import axiosClient from "../../../config/axios";

const saveSurvey = async surveData => {
    try {
        const headers = { 'Content-Type': 'application/json' };
        const response = await axiosClient.post('/satisfaction-survey-qr/generate-v2', surveData, { headers });
        console.log(response)
        return response;
    } catch (error) {
        const { response } = error;
        return response;
    }
}

export {
    saveSurvey,
}